var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mypage"},[_c('el-pagination',{attrs:{"background":"","page-size":10,"current-page":_vm.page,"layout":"total,prev, pager, next, sizes, jumper","total":_vm.total},on:{"current-change":_vm.currentChange,"size-change":_vm.sizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }